import { render, staticRenderFns } from "./info_bdpersonas.vue?vue&type=template&id=60971106"
import script from "./info_bdpersonas.vue?vue&type=script&lang=js"
export * from "./info_bdpersonas.vue?vue&type=script&lang=js"
import style0 from "./info_bdpersonas.vue?vue&type=style&index=0&id=60971106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports